import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { debounceTime, startWith, take, takeUntil } from 'rxjs/operators';
import { FilterValue } from '../../../../app/interfaces/base/filter-value';
import { FormControl } from '@angular/forms';
import { ApiService } from '../../../../app/services/base/api.service';
import { FiltersService } from '../../../../app/services/base/filters.service';
import { Filters } from '../../../../app/interfaces/base/filters';
import { Tile } from '../../../../app/interfaces/routering/tile';

@Component({
  selector: 'fury-table-filter-task-number',
  templateUrl: './table-filter-task-number.component.html',
  styleUrls: ['./table-filter-task-number.component.scss']
})
export class TableFilterTaskNumberComponent implements OnInit, AfterViewInit, OnDestroy {

  public filters: Filters = {
    tiles: {
      preload: true,
      isLoading: false,
      data: <Tile[]>[]
    },
  };

  public isFiltered: boolean = false;

  public reportNumberAbbreviation: string = 'Z';

  @ViewChild('reportNumberAbbreviationEl') reportNumberAbbreviationEl: ElementRef;

  @Input() name: string = null;

  @Input() customFiltering: boolean = false;
  @Output() clearFilter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();

  public tileSelection: FormControl = new FormControl<string>('');
  public element: FormControl = new FormControl<string>('');

  private destroy$: Subject<null> = new Subject<null>();

  constructor(
    private api: ApiService,
    private cd: ChangeDetectorRef,
    private filtersService: FiltersService,
  ) {
  }

  @HostListener('keydown.space', ['$event'])
  @HostListener('click', ['$event']) onClick(e: Event): void {
    e.stopPropagation();
  }

  ngOnInit(): void {
    Object.keys(this.filters).map((key: string): void => {
      if (this.filters[key].preload) {
        this.filtersService[key]().pipe(takeUntil(this.destroy$)).subscribe((data: any): void => this.filters[key].data = data);
      }
    });
  }

  ngAfterViewInit(): void {
    // position "Filter" text
    (document.querySelector('.task-number-element .mat-form-field-label-wrapper') as HTMLElement).style.left = '-' + (39 + this.reportNumberAbbreviationEl.nativeElement.offsetWidth) + 'px';

    combineLatest([
      this.tileSelection.valueChanges,
      this.element.valueChanges
    ]).pipe(
      debounceTime(500),
      takeUntil(this.destroy$),
    ).subscribe((value: [number, string]): void => {
      console.log(value);
      if (value.length !== 2) {
        return;
      }

      let endValue: string = this.reportNumberAbbreviation + value[0] + (value[1] ? value[1] : '');
      if (endValue === '') {
        endValue = null;
      }

      this.isFiltered = !!endValue;

      if (this.customFiltering) {
        (value ? this.filterChange.emit(endValue) : this.clearFilter.next());
      } else {
        (value ? this.api.setFilter(this.name, endValue) : this.api.clearFilter(this.name));
      }
    });

    this.api.preSetFilters.pipe(
      take(1),
      takeUntil(this.destroy$)
    ).subscribe((filters: FilterValue[]): void => {
      filters.forEach((filter: FilterValue): void => {
        if (this.name === filter.name) {
          if (filter.value) {
            if ((<string>filter.value).indexOf('-') !== -1) {
              const value: string[] = [
                (<string>filter.value).slice(3, 5),
                (<string>filter.value).slice(6),
              ];
              this.isFiltered = !!value;

              this.tileSelection.setValue(value[0]);
              this.element.setValue(value[1], {emitEvent: false});
            }
          }
          this.cd.detectChanges();
        }
      });
    });

    this.api.filterCleared.pipe(takeUntil(this.destroy$)).subscribe((): void => this.clearFilterButton());
    this.api.clearAllFilters.pipe(takeUntil(this.destroy$)).subscribe((): void => this.clearFilterButton(false));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  clearFilterButton(emitEvent: boolean = true): void {
    this.tileSelection.setValue(null);
    this.element.setValue('');
    this.isFiltered = false;

    if (emitEvent) {
      if (this.customFiltering) {
        this.clearFilter.next();
      } else {
        this.api.clearFilter(this.name);
      }
    }
  }
}
